export const validation_errors = {
  field: {
    start: 'Start date field:',
    end: 'End date field:',
    number: 'Number field:',
    status: 'Status field:',
    state: 'Status field:',
    name: 'Name field:',
    login: 'Login'
  },
  value: {
    'Peer already exists': 'already exists',

    validation: {
      required: 'must be required',
      integer: 'must be a number',
      string: 'must be a string'
    },
    'Date range must be less a month': 'Date range must not exceed 1 month'
  },
  enter_date: 'Enter dates'
};
